import * as go from 'gojs'

// RoundedTopRectangle and RoundedBottomRectangle from https://gojs.net/latest/intro/shapes.html

function _tdsCommonShapeDefinition (shape, w, h, geoFn) {
  // this figure takes one parameter, the size of the corner
  var p1 = 5 // default corner size
  if (shape !== null) {
    var param1 = shape.parameter1
    if (!isNaN(param1) && param1 >= 0) p1 = param1 // can't be negative or NaN
  }
  p1 = Math.min(p1, w / 2)
  p1 = Math.min(p1, h / 2) // limit by whole height or by half height?
  var geo = new go.Geometry()
  geoFn(geo, p1)
  return geo
}

function defineCustomShapes () {
  go.Shape.defineFigureGenerator('RoundedTopRectangle', function (shape, w, h) {
    return _tdsCommonShapeDefinition(shape, w, h, (geo, p1) => {
      geo.add(new go.PathFigure(0, p1)
        .add(new go.PathSegment(go.PathSegment.Arc, 180, 90, p1, p1, p1, p1))
        .add(new go.PathSegment(go.PathSegment.Line, w - p1, 0))
        .add(new go.PathSegment(go.PathSegment.Arc, 270, 90, w - p1, p1, p1, p1))
        .add(new go.PathSegment(go.PathSegment.Line, w, h + 1))
        .add(new go.PathSegment(go.PathSegment.Line, 0, h + 1).close()))
    })
  })

  go.Shape.defineFigureGenerator('RoundedBottomRectangle', function (shape, w, h) {
    /*
     *  1------2
     *         |
     *         |
     *  6      3
     *  \      /
     *   5----4
     *
     */
    return _tdsCommonShapeDefinition(shape, w, h, (geo, p1) => {
      geo.add(new go.PathFigure(0, 0)
        .add(new go.PathSegment(go.PathSegment.Line, w, 0))
        .add(new go.PathSegment(go.PathSegment.Line, w, h - p1))
        .add(new go.PathSegment(go.PathSegment.Arc, 0, 90, w - p1, h - p1, p1, p1))
        .add(new go.PathSegment(go.PathSegment.Line, p1, h))
        .add(new go.PathSegment(go.PathSegment.Arc, 90, 90, p1, h - p1, p1, p1).close()))
      // don't intersect with two top corners when used in an "Auto" Panel
      geo.spot1 = new go.Spot(0, 0, 0.3 * p1, 0.3 * p1)
      geo.spot2 = new go.Spot(1, 1, -0.3 * p1, 0)
    })
  })

  go.Shape.defineFigureGenerator('RoundedLeftRectangle', function (shape, w, h) {
    /*
     *   2------1
     *  /
     *  3
     *  |
     *  |
     *  4
     *  \
     *   5------6
     *
     * 0 is to the right; 90 is down; 180 is to the left; 270 is up
     */
    return _tdsCommonShapeDefinition(shape, w, h, (geo, p1) => {
      geo.add(new go.PathFigure(w, 0)
        .add(new go.PathSegment(go.PathSegment.Line, p1, 0))
        .add(new go.PathSegment(go.PathSegment.Arc, 270, -90, p1, p1, p1, p1))
        .add(new go.PathSegment(go.PathSegment.Line, 0, h - p1))
        .add(new go.PathSegment(go.PathSegment.Arc, 180, -90, p1, h - p1, p1, p1))
        .add(new go.PathSegment(go.PathSegment.Line, w, h).close()))
    })
  })

  go.Shape.defineFigureGenerator('RoundedRightRectangle', function (shape, w, h) {
    /*
     *  1-----2
     *         \
     *          3
     *          |
     *          |
     *          4
     *         /
     *   6----5
     *
     * 0 is to the right; 90 is down; 180 is to the left; 270 is up
     */
    return _tdsCommonShapeDefinition(shape, w, h, (geo, p1) => {
      geo.add(new go.PathFigure(0, 0)
        .add(new go.PathSegment(go.PathSegment.Line, w - p1, 0))
        .add(new go.PathSegment(go.PathSegment.Arc, 270, 90, w - p1, p1, p1, p1))
        .add(new go.PathSegment(go.PathSegment.Line, w, h - p1))
        .add(new go.PathSegment(go.PathSegment.Arc, 0, 90, w - p1, h - p1, p1, p1))
        .add(new go.PathSegment(go.PathSegment.Line, 0, h).close()))
    })
  })

  go.Shape.defineFigureGenerator('TdsDownArrow', function (shape, w, h) {
    return new go.Geometry()
      .add(new go.PathFigure(0, 0, false)
        .add(new go.PathSegment(go.PathSegment.Line, 0.5 * w, h))
        .add(new go.PathSegment(go.PathSegment.Line, w, 0)))
  })

  go.Shape.defineFigureGenerator('TdsUpArrow', function (shape, w, h) {
    return new go.Geometry()
      .add(new go.PathFigure(0, h, false)
        .add(new go.PathSegment(go.PathSegment.Line, 0.5 * w, 0))
        .add(new go.PathSegment(go.PathSegment.Line, w, h)))
  })
}

export { defineCustomShapes }



// WEBPACK FOOTER //
// ./src/graph_parts/shapes.js